module.exports = __webpack_public_path__ + "img/ec.024caa8.svg";